import axios from './axiosInstances/axiosInstance';

export const getBillingSchemesAccounts = (basketId) => {
  return axios.get(`/baskets/${basketId}/billingschemes`);
};
